import { Action, createReducer, on } from '@ngrx/store';
import { setSettingsStateAction, updateScannerSettingsAction } from '../actions/settings.action';

export interface ScannerSettingsState {
  scanner?: string;
  resolution: string;
  colorMode: string;
  format: string;
  pages?: number;
}

export interface SettingsReducerInitialState {
  sideMenuCollapsedState: boolean;
  scanner: ScannerSettingsState;
}

export const initialState: SettingsReducerInitialState = {
  sideMenuCollapsedState: false,
  scanner: {
    resolution: '300dpi',
    colorMode: 'color',
    format: 'pdf',
    pages: 1,
  },
};

const reducer = createReducer(
  initialState,
  on(setSettingsStateAction, (state, payload) => {
    return {
      ...state,
      ...payload,
    };
  }),
  on(updateScannerSettingsAction, (state, { scanner }) => {
    return {
      ...state,
      scanner: {
        ...state.scanner,
        ...scanner,
      },
    };
  }),
);

export function settingsReducer(state: SettingsReducerInitialState = initialState, action: Action) {
  return reducer(state, action);
}
